// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchNavbarComponents-cls1_zZB","cls2":"SearchNavbarComponents-cls2_60t SearchNavbarComponents-cls1_zZB"};